import { render } from "./loadprogress.vue?vue&type=template&id=490e7c6c&scoped=true"
import script from "./loadprogress.vue?vue&type=script&lang=js"
export * from "./loadprogress.vue?vue&type=script&lang=js"

import "./loadprogress.vue?vue&type=style&index=0&id=490e7c6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490e7c6c"]])

export default __exports__